module.exports = __webpack_public_path__ + "static/media/MicCompany.a581f373.svg";